export default "__VITE_ASSET__C6ZWcZPO__"